export default {
  请去APP端进行操作: '请去APP端进行操作',
  最多填写20个数字: '最多填写20个数字',
  最多填写15个数字: '最多填写15个数字',
  最多填写20个汉字: '最多填写20个汉字',
  最多填写30个汉字: '最多填写30个汉字',
  最多填写30个汉字2: '最多填写30个汉字',
  最多填写300个汉字: '最多填写300个汉字',
  最多填写5000个汉字: '最多填写5000个汉字',
  请输入企业简介: '请输入企业简介',
  请输入企业名称: '请输入企业名称',
  '请输入正确的固定电话,如：0341-86091234': '请输入正确的固定电话,如：0341-86091234',
  申请入驻请点击: '申请入驻请点击',
  待开幕: '待开幕',
  进行中: '进行中',
  已结束: '已结束',
  待开展: '待开展',
  开展中: '开展中',
  '参加展览、会议、展示企业信息、产品等~': '参加展览、会议、展示企业信息、产品等~',
  '组织举办云上展览、线下展览、会议等等~': '组织举办云上展览、线下展览、会议等等~',
  '提供展厅模型下载、展厅搭建施工服务等~': '提供展厅模型下载、展厅搭建施工服务等~',
  '设计海报以及模型供用户下载使用,人性化设计服务,获得高额分成~':
    '设计海报以及模型供用户下载使用,人性化设计服务,获得高额分成~',
  添加产品成功: '添加产品成功',
  请选中产品后添加: '请选中产品后添加',
  审核中: '审核中',
  审核拒绝: '审核拒绝',
  待平台审核: '待平台审核',
  平台拒绝通过: '平台拒绝通过',
  待主账号审核: '待主账号审核',
  主账号拒绝通过: '主账号拒绝通过',
  '该内容已下架,无法操作': '该内容已下架,无法操作',
  提前结束展览成功: '提前结束展览成功',
  查看详情: '查看详情',
  暂无可添加的产品: '暂无可添加的产品',
  添加企业展品: '添加企业展品',
  邀请海报: '邀请海报',
  我要直播: '我要直播',
  备注: '备注',
  完工时间: '完工时间',
  微信: '微信',
  联系电话: '联系电话',
  名称: '名称',
  报名信息: '报名信息',
  看直播: '看直播',
  展览地址: '展览地址',
  开幕时间: '开幕时间',
  自动结束: '自动结束',
  主动结束: '主动结束',
  抽审下架: '抽审下架',
  审核通过: '审核通过',
  待审核: '待审核',
  发布展览: '发布展览',
  发布中: '发布中',
  已驳回: '已驳回',
  查看原因: '查看原因',
  知道了: '知道了',
  编辑类型: '编辑类型',
  提交时间: '提交时间',
  已通过: '已通过',
  已拒绝: '已拒绝',
  企业名称关键词: '企业名称关键词',
  // 产品
  发布产品: '发布产品',
  参展成功报名后提示语:
    '提示：参展展览报名成功后,请尽快发布产品进行参展,发布的产品审核通过后,该产品则默认参展所报名的参展展览！',
  审核成功: '审核成功',
  通过: '通过',
  驳回: '驳回',
  驳回成功: '驳回成功',
  撤销成功: '撤销成功',
  确定继续该撤销操作吗: '确定继续该撤销操作吗？',
  撤销: '撤销',
  拒绝原因: '拒绝原因',
  参展商审核通过提示: '请再次确认,审核通过之后,该参展商即可在您发布的云上展览进行参展,并可上架产品。',
  申请时间: '申请时间',
  审核状态: '审核状态',
  客户备注: '客户备注',
  产品标题: '产品标题',
  请选择产品行业分类: '请选择产品行业分类',
  确认下架该产品吗: '确认下架该产品吗？',
  置顶: '置顶',
  取消置顶: '取消置顶',
  下架: '下架',
  重新上架: '重新上架',
  新增: '新增',
  平台抽审下架原因: '平台抽审下架原因:',
  产品封面: '产品封面',
  产品信息: '产品信息',
  产品列表: '产品列表',
  确认删除当前规格吗: '确认删除当前规格吗？',
  在线产品: '在线产品',
  确认下架该模型吗: '确认下架该模型吗？',
  确认上架该模型吗: '确认上架该模型吗',
  下架模型成功: '下架模型成功',
  重新上架模型成功: '重新上架模型成功',
  购买人数详情: '购买人数详情',
  购买人数: '购买人数',
  下载人数: '下载人数',
  收藏人数: '收藏人数',
  立即发布: '立即发布',
  // 基本资料
  个人信息: '个人信息',
  未添加手机号: '未添加手机号',
  更换手机号: '更换手机号',
  添加手机号: '添加手机号',
  可用于登录云展动力各个终端平台: '可用于登录云展动力各个终端平台',
  更换邮箱: '更换邮箱',
  添加邮箱: '添加邮箱',
  登录密码: '登录密码',
  我的邀请: '我的邀请',
  我的邀请码: '我的邀请码',
  '可复制您的邀请码给亲友进行注册,获取更多权益': '可复制您的邀请码给亲友进行注册,获取更多权益',
  企业行业属性: '企业行业属性',
  感兴趣的行业: '感兴趣的行业',
  '设置企业行业属性,获取更精准的数据营销推送': '设置企业行业属性,获取更精准的数据营销推送',
  '设置感兴趣的行业,获取更多更精准的头条推荐': '设置感兴趣的行业,获取更多更精准的头条推荐',
  // 基本资料-个人身份
  真实姓名: '真实姓名',
  身份证号码: '身份证号码',
  自我介绍: '自我介绍',
  // 基本资料-按钮
  更换: '更换',
  修改: '修改',
  添加: '添加',
  复制: '复制',
  // 基本资料-更换手机或邮箱弹框
  最多30个字符: '最多30个字符',
  修改用户名: '修改用户名',
  解除绑定: '解除绑定',
  修改用户名成功: '修改用户名成功',
  修改邮箱成功: '修改邮箱成功',
  '用户名不可超过30个字符,15个汉字！': '用户名不可超过30个字符,15个汉字！',
  '请输入用户名！': '请输入用户名！',
  '密码长度为6-18位,建议字母、数字混合设置': '密码长度为6-18位,建议字母、数字混合设置',
  当前手机号: '当前手机号',
  当前邮箱: '当前邮箱',
  '为了您的账号安全,请先请输入当前手机号的验证码,验证是否为本人操作':
    '为了您的账号安全,请先请输入当前手机号的验证码,验证是否为本人操作',
  '为了您的账号安全,请先请输入当前邮箱的验证码,验证是否为本人操作':
    '为了您的账号安全,请先请输入当前邮箱的验证码,验证是否为本人操作',
  '请确保新增的手机号为全新未注册的11位纯数字手机号,且首位数字为1':
    '请确保新增的手机号为全新未注册的11位纯数字手机号,且首位数字为1',
  请确保添加的邮箱为全新未注册: '请确保添加的邮箱为全新未注册',
  请输入当前手机号的验证码: '请输入当前手机号的验证码',
  请输入当前邮箱的验证码: '请输入当前邮箱的验证码',
  新手机号: '新手机号',
  新邮箱: '新邮箱',
  '请确保所更换的手机号为全新未注册的11位纯数字手机号,否则无法更换':
    '请确保所更换的手机号为全新未注册的11位纯数字手机号,否则无法更换',
  请输入新手机号: '请输入新手机号',
  请输入新邮箱: '请输入新邮箱',
  新手机号验证码: '新手机号验证码',
  新邮箱验证码: '新邮箱验证码',
  请输入新手机号验证码: '请输入新手机号验证码',
  请输入新邮箱验证码: '请输入新邮箱验证码',
  未添加邮箱: '未添加邮箱',
  暂未绑定: '暂未绑定',
  // 基本资料-密码
  修改登录密码: '修改登录密码',
  原密码: '原密码',
  请输入原密码: '请输入原密码',
  新密码: '新密码',
  请输入新密码: '请输入新密码',
  再次设置新密码: '再次设置新密码',
  // 基本资料-修改头像
  修改头像: '修改头像',
  更换头像: '更换头像',
  重新选择: '重新选择',
  个人头像上传提示: '请选择图片上传：大小200 * 200像素支持JPG、PNG格式,图片需小于5M',
  // 基本资料-修改企业行业属性
  选择您所属行业: '选择您所属行业',
  选择您感兴趣的行业: '选择您感兴趣的行业',
  '为了更好提供精准的数据服务, 请选择您感兴趣的行业': '为了更好提供精准的数据服务, 请选择您感兴趣的行业',
  选择感兴趣的行业: '选择感兴趣的行业',
  请选择您感兴趣的行业: '请选择您感兴趣的行业',
  '为了更好提供精准的数据服务,请选择您感兴趣的行业': '为了更好提供精准的数据服务,请选择您感兴趣的行业',
  '为了更好提供精准的数据服务,请选择您所属的行业': '为了更好提供精准的数据服务,请选择您所属的行业',
  '确定,下一步': '确定,下一步',
  请选择您所属的行业: '请选择您所属的行业',
  最多可选择5个行业: '最多可选择5个行业',
  请至少选择一个所属行业: '请至少选择一个所属行业',
  // 标题是动态的
  '您发布的内容《标题》正在审核中,平台预计2-3个工作日完成审核,审核结果会以站内信通知,请耐心等待！':
    '您发布的内容《标题》正在审核中,平台预计2-3个工作日完成审核,审核结果会以站内信通知,请耐心等待！',
  '请填写赞助商名称,审核通过之后,该赞助商名称即显示在您发布的会议详情中':
    '请填写赞助商名称,审核通过之后,该赞助商名称即显示在您发布的会议详情中',
  请输入赞助商名称: '请输入赞助商名称',
  '请确认是否驳回该赞助商？': '请确认是否驳回该赞助商？',
  // 招标管理
  发布招标: '发布招标',
  // 我的钱包
  '因目前相关政策限制,充值成功后,充值资金仅限于购买本站付费服务或购买本站提供的第三方付费服务,不支持任何形式与理由提现或者退款,敬请知悉！':
    '因目前相关政策限制,充值成功后,充值资金仅限于购买本站付费服务或购买本站提供的第三方付费服务,不支持任何形式与理由提现或者退款,敬请知悉！',
  '金币充值1元起充,1元=1金币(可用于会员充值、海报购买、模型购买等);':
    '金币充值1元起充,1元=1金币(可用于会员充值、海报购买、模型购买等);',
  '充值金额不可提现,仅收入金额可提现,提现申请将于15个工作日内完成审核,节假日顺延':
    '充值金额不可提现,仅收入金额可提现,提现申请将于15个工作日内完成审核,节假日顺延',
  总金额: '总金额',
  充值金额: '充值金额',
  收入金额: '收入金额',
  提现中收入金额: '提现中收入金额',
  普通收入: '普通收入',
  活动收入: '活动收入',
  交易明细: '交易明细',
  消费: '消费',
  收入: '收入',
  提现: '提现',
  提现详情: '提现详情',
  提现编号: '提现编号',
  提现时间: '提现时间',
  申请提现金额: '申请提现金额',
  手续费率: '手续费率',
  手续费: '手续费',
  预估到账金额: '预估到账金额',
  提现终端: '提现终端',
  提现中: '提现中',
  提现成功: '提现成功',
  提现失败: '提现失败',
  提现信息: '提现信息',
  提现到支付宝账号: '提现到支付宝账号',
  支付宝账号的收款人姓名: '支付宝账号的收款人姓名',
  转账信息: '转账信息',
  出款支付宝账户: '出款支付宝账户',
  银行: '银行',
  支付宝账户银行卡转账: '支付宝账户银行卡转账',
  支付宝余额转账: '支付宝余额转账',
  出款方式: '出款方式',
  实际提现到账金额: '实际提现到账金额',
  操作时间: '操作时间',
  交易状态: '交易状态',
  订单号: '订单号',
  订单详情: '订单详情',
  下单时间: '下单时间',
  实际交易金额: '实际交易金额',
  商户订单号: '商户订单号',
  财务类型: '财务类型',
  交易时间: '交易时间',
  '收支金额(金币)': '收支金额(金币)',
  充值编号: '充值编号',
  充值方式: '充值方式',
  当前账户余额: '当前账户余额',
  // 消息中心
  通知: '通知',
  暂无通知: '暂无通知',
  暂无洽谈: '暂无洽谈',
  站内信: '站内信',
  站内信为空: '站内信为空',
  // 洽谈框
  暂无对方基本信息: '暂无对方基本信息',
  '聊天记录支持多端同步,并最多保存最近90天聊天记录': '聊天记录支持多端同步,并最多保存最近90天聊天记录!',
  表情: '表情',
  图片: '图片',
  视频: '视频',
  音频: '音频',
  音频下载失败: '音频下载失败',
  文件: '文件',
  聊天记录: '聊天记录',
  挂断: '挂断',
  接通: '接通',
  '未检测到摄像头、麦克风,请检查设备或转移手机 App继续视频': '未检测到摄像头、麦克风,请检查设备或转移手机 App继续视频',
  '未检测到摄像头、麦克风,请检查设备或转移手机 App继续音频': '未检测到摄像头、麦克风,请检查设备或转移手机 App继续音频',
  等待对方接受邀请: '等待对方接受邀请',
  邀请您语音通话: '邀请您语音通话',
  邀请您视频通话: '邀请您视频通话',
  // 语音聊天: '语音聊天',
  // 视频聊天: '视频聊天',
  // 对方拒绝视频聊天: '对方拒绝视频聊天',
  // 对方拒绝语音聊天: '对方拒绝语音聊天',
  // 已拒绝视频聊天: '已拒绝视频聊天',
  // 已拒绝语音聊天: '已拒绝语音聊天',
  // 您有未接视频聊天请求: '您有未接视频聊天请求',
  // 您有未接语音聊天请求: '您有未接语音聊天请求',
  // 对方未接通: '对方未接通',
  // '对方在忙!请稍后再拨打': '对方在忙!请稍后再拨打',
  // '对方未上线,发起视频聊天失败!': '对方未上线,发起视频聊天失败!',
  // 已取消视频聊天: '已取消视频聊天',
  // 已取消语音聊天: '已取消语音聊天',
  对方已取消视频聊天: '对方已取消视频聊天',
  对方已取消语音聊天: '对方已取消语音聊天',
  已取消视频聊天: '已取消视频聊天',
  已取消语音聊天: '已取消语音聊天',
  视频聊天: '视频聊天',
  语音聊天: '语音聊天',
  您有未接语音聊天请求: '您有未接语音聊天请求',
  您有未接视频聊天请求: '您有未接视频聊天请求',
  对方未接通: '对方未接通',
  '对方在忙！请稍后再拨打！': '对方在忙！请稍后再拨打！',
  已拒绝语音聊天: '已拒绝语音聊天',
  已拒绝视频聊天: '已拒绝视频聊天',
  对方拒绝您的语音聊天请求: '对方拒绝您的语音聊天请求',
  对方拒绝您的视频聊天请求: '对方拒绝您的视频聊天请求',
  '对方未上线,发起语音聊天失败': '对方未上线,发起语音聊天失败',
  '对方未上线,发起视频聊天失败': '对方未上线,发起视频聊天失败',
  '对方在忙,请稍后再拨打': '对方在忙请稍后再拨打',
  对方已挂断: '对方已挂断',
  '对方或己方网络质量不佳,请及时处理': '对方或己方网络质量不佳,请及时处理',
  对方拒绝通话: '对方拒绝通话',
  '网络连接超时,已断开': '网络连接超时,已断开',
  '对方不在线,请稍后重试': '对方不在线,请稍后重试',
  '对方未接通,请稍后重试': '对方未接通,请稍后重试',
  // 其他
  岗位不能为空: '岗位不能为空',
  报名日期: '报名日期',
  备注内容: '备注内容',
  进入会员中心: '进入会员中心',
  回到首页: '回到首页',
  前往主页: '前往主页',
  标题: '标题',
  发布用户: '发布用户',
  下午好: '下午好',
  上午好: '上午好',
  收藏数: '收藏数',
  '提示：滚动鼠标中间键,可以缩放图片大小': '提示：滚动鼠标中间键,可以缩放图片大小',
  // 其他
  '抱歉,没有找到筛选的相关现场直播': '抱歉,没有找到筛选的相关现场直播',
  '抱歉,没有找到筛选的相关企业展品': '抱歉,没有找到筛选的相关企业展品',
  '抱歉,没有找到筛选的相关企业3D': '抱歉,没有找到筛选的相关企业3D',
  // 当前内容,非原创,转载于（渠道）
  '非原创,转载于': '非原创,转载于',
  开播: '开播',
  下架产品: '下架产品',
  采购单号: '采购单号',
  招标标题: '招标标题',
  招标列表: '招标列表',
  请选择招标类型: '请选择招标类型',
  请选择招标地区: '请选择招标地区',
  招标行业分类: '招标行业分类',
  请选择招标行业分类: '请选择招标行业分类',
  在线招标: '在线招标',
  浏览招标详情: '浏览招标详情',
  请输入招标标题: '请输入招标标题',
  招标内容: '招标内容',
  请输入招标详细内容: '请输入招标详细内容',
  立刻发布: '立刻发布',
  展品分类: '展品分类',
  请选择展品类型: '请选择展品类型',
  展品标题: '展品标题',
  订单类型: '订单类型',
  '电子普通发票和纸质普通发票具备同等法律效力,可支持报销入账,平台在订单完成后1-3个工作日内开具,请留意您的邮箱':
    '电子普通发票和纸质普通发票具备同等法律效力,可支持报销入账,平台在订单完成后1-3个工作日内开具,请留意您的邮箱',
  '已开票,请留意您发票接收邮箱': '已开票,请留意您发票接收邮箱',
  模型编号: '模型编号',
  海报编号: '海报编号',
  立即观看: '立即观看',
  申请发票: '申请发票',
  订单编号: '订单编号',
  海报设计: '海报设计',
  会员服务: '会员服务',
  交易金额: '交易金额',
  商家信息: '商家信息',
  商家: '商家',
  发票信息: '发票信息',
  发票类型: '发票类型',
  发票内容: '发票内容',
  发票抬头: '发票抬头',
  个人名称: '个人名称',
  单位名称: '单位名称',
  纳税识别码: '纳税识别码',
  收票人邮箱: '收票人邮箱',
  收票人手机: '收票人手机',
  开票中: '开票中',
  已出票: '已出票',
  转载备注: '转载备注',
  // 我的直播
  播放: '播放',
  创建直播: '创建直播',
  继续直播: '继续直播',
  我的回放: '我的回放',
  重新直播: '重新直播',
  直播信息: '直播信息',
  直播时间: '直播时间',
  添加展品: '添加展品',
  直播已结束: '直播已结束',
  实际开播时间: '实际开播时间',
  实际结束时间: '实际结束时间',
  直播时长: '直播时长',
  累计观看人数: '累计观看人数',
  采购单数: '采购单数',
  累计成交金额: '累计成交金额',
  直播已禁播: '直播已禁播',
  当前在线人数: '当前在线人数',
  '累计观看（人次）': '累计观看（人次）',
  直播数据: '直播数据',
  请选择要添加的产品: '请选择要添加的产品',
  直播回放信息: '直播回放信息',
  请选择子账号类型: '请选择子账号类型',
  // 展览管理-发布展览
  权限问题: '权限问题',
  '没有权限发布展览,请联系客服': '没有权限发布展览,请联系客服',
  '展览类型错误,请联系客服': '展览类型错误,请联系客服',
  发布新展览: '发布新展览',
  '我已阅读以上须知,确定创建该类展览': '我已阅读以上须知,确定创建该类展览',
  展览信息: '展览信息',
  展览属性: '展览属性',
  展览标题: '展览标题',
  请输入展览标题: '请输入展览标题',
  点击上传图片: '点击上传图片',
  展览主图: '展览主图',
  '图片格式为JPG/PNG,分辨率540*300,大小不能超过2M': '图片格式为JPG/PNG,分辨率540*300,大小不能超过2M',
  展览时间: '展览时间',
  结束时间: '结束时间',
  请输入届次: '请输入届次',
  纯数字: '纯数字',
  参展联络: '参展联络',
  '中国（+86）': '中国（+86）',
  请输入固定电话: '请输入固定电话',
  联系微信: '联系微信',
  请输入微信: '请输入微信',
  请输入公司官网地址: '请输入公司官网地址',
  '请输入主办单位名称,若有多个,则一行一个,每行200个字符内,最多20行':
    '请输入主办单位名称,若有多个,则一行一个,每行200个字符内,最多20行',
  '请输入支持单位名称,若有多个,则一行一个,每行200个字符内,最多20行':
    '请输入支持单位名称,若有多个,则一行一个,每行200个字符内,最多20行',
  '请输入承办单位名称,若有多个,则一行一个,每行200个字符内,最多20行':
    '请输入承办单位名称,若有多个,则一行一个,每行200个字符内,最多20行',
  '请输入协办单位名称,若有多个,则一行一个,每行200个字符内,最多20行':
    '请输入协办单位名称,若有多个,则一行一个,每行200个字符内,最多20行',
  基本信息: '基本信息',
  '3D超链接': '3D超链接',
  '若有3D展示,则输入展览3D超链接': '若有3D展示,则输入展览3D超链接',
  请输入展览简介: '请输入展览简介',
  请输入展览范围: '请输入展览范围',
  提示: '提示',
  展览类型: '展览类型',
  请选择展览类型: '请选择展览类型',
  最多输20行: '最多输20行',
  每行60个字符内: '每行60个字符内',
  请至少增加一个自定义标签: '请至少增加一个自定义标签',
  请填写展览费用中标准展位的国内企业费用: '请填写展览费用中标准展位的国内企业费用',
  请填写展览费用中标准展位的境外企业费用: '请填写展览费用中标准展位的境外企业费用',
  请填写展览费用中标准展位的展位物品清单: '请填写展览费用中标准展位的展位物品清单',
  请填写展馆信息中的展馆名称: '请填写展馆信息中的展馆名称',
  请填写展馆信息中的展馆详细地址: '请填写展馆信息中的展馆详细地址',
  请上传展馆信息中的展馆图片: '请上传展馆信息中的展馆图片',
  '提交展览信息成功,请等待审核': '提交展览信息成功,请等待审核',
  '请上传 480*270 尺寸以上图片,当前图片': '请上传 480*270 尺寸以上图片,当前图片',
  标签只可以输出三十个字以内: '标签只可以输出三十个字以内',
  自定义标签最多10个: '自定义标签最多10个',
  '请上传 1920*430 固定尺寸图片,当前图片': '请上传 1920*430 固定尺寸图片,当前图片',
  '请上传 540*300 尺寸以上图片,当前图片': '请上传 540*300 尺寸以上图片,当前图片',
  '请勿上传涉黄、广告、反动、政治性等违禁照片,否则按照平台相关规定处理,严重者上报监管部门':
    '请勿上传涉黄、广告、反动、政治性等违禁照片,否则按照平台相关规定处理,严重者上报监管部门',
  暂无上传的照片: '暂无上传的照片',
  单击或将文件拖到该区域以上传: '单击或将文件拖到该区域以上传',
  '支持单次或批量上传。 单张图片限 5MB 以内,格式：JPG/JPEG/PNG':
    '支持单次或批量上传。 单张图片限 5MB 以内,格式：JPG/JPEG/PNG',
  图片上传成功: '图片上传成功',
  图片上传失败: '图片上传失败',
  '图片路径为空,关联展览失败': '图片路径为空,关联展览失败',
  // 《违反原因》 驳回原因
  '您发布的内容违反了《违反原因》,请修改再重新发布！': '您发布的内容违反了《违反原因》,请修改再重新发布！',
  企业认证申请·主办商: '企业认证申请·主办商',
  企业认证申请·工程商: '企业认证申请·工程商',
  企业认证申请·设计师: '企业认证申请·设计师',
  企业认证申请·参展商: '企业认证申请·参展商',
  展厅搭建申请: '展厅搭建申请',
  裁剪: '裁剪',
  // 会议管理
  历史会议: '历史会议',
  发布会议: '发布会议',
  图形验证码: '图形验证码',
  请输入图片中的验证码: '请输入图片中的验证码',
  发布新会议: '发布新会议',
  '我已阅读以上须知,确定创建该类会议': '我已阅读以上须知,确定创建该类会议',
  会议信息: '会议信息',
  会议属性: '会议属性',
  会议标题: '会议标题',
  请输入会议标题: '请输入会议标题',
  会议主图: '会议主图',
  参会联络: '参会联络',
  请输入会议简介: '请输入会议简介',
  会议嘉宾: '会议嘉宾',
  请输入会议嘉宾: '请输入会议嘉宾',
  请输入会议日程: '请输入会议日程',
  会场名称: '会场名称',
  请输入会场标题: '请输入会场标题',
  会场图片: '会场图片',
  '图片格式为JPG/PNG,大小不能超过2M': 'JPG/PNG formats are accepted. Maximum file size: 2M',
  请输入会议门票: '请输入会议门票',
  '会议简介、会议嘉宾、会议日程、会场信息、会议门票不允许出现任何联系方式、反动、暴力以及色情等相关内容':
    '会议简介、会议嘉宾、会议日程、会场信息、会议门票不允许出现任何联系方式、反动、暴力以及色情等相关内容',
  '若需要请在【参会联络】进行完善,否则审批不通过！': '若需要请在【参会联络】进行完善,否则审批不通过！',
  请上传会议主图: '请上传会议主图',
  会议时间不能为空: '会议时间不能为空',
  请输入会议面积: '请输入会议面积',
  请输入举办年数: '请输入举办年数',
  请输入举办次数: '请输入举办次数',
  请输入导读简介: '请输入导读简介',
  '提交会议信息成功,请等待审核': '提交会议信息成功,请等待审核',
  // 头条
  发布头条: '发布头条',
  发布新头条: '发布新头条',
  线上头条: '线上头条',
  历史头条: '历史头条',
  头条详情: '头条详情',
  下架头条成功: '下架头条成功',
  请输入头条标题: '请输入头条标题',
  最多填写65个汉字: '最多填写65个汉字',
  请上传头条主图: '请上传头条主图',
  请输入头条详细内容: '请输入头条详细内容',
  请选择头条来源: '请选择头条来源',
  '请填写转载来源,最多填写20个汉字': '请填写转载来源,最多填写20个汉字',
  请输入原创姓名: '请输入原创姓名',
  请认真阅读后同意协议: '请认真阅读后同意协议',
  头条分类: '头条分类',
  头条行业分类: '头条行业分类',
  请选择头条行业分类: '请选择头条行业分类',
  '我已阅读以上须知,确定创建该类头条': '我已阅读以上须知,确定创建该类头条',
  头条信息: '头条信息',
  头条属性: '头条属性',
  头条标题: '头条标题',
  头条主图: '头条主图',
  点击上传主图: '点击上传主图',
  头条来源: '头条来源',
  原创: '原创',
  转载: '转载',
  请输入姓名: '请输入姓名',
  头条内容: '头条内容',
  '招标标题不能为空！': '招标标题不能为空！',
  '招标正文不能为空！': '招标正文不能为空！',
  请选择或输入搜索招标地区: '请选择或输入搜索招标地区',
  '账单生成,每月10号系统会自动生成上月业务账单,选择账单即可申请开具电子普通发票；':
    '账单生成,每月10号系统会自动生成上月业务账单,选择账单即可申请开具电子普通发票；',
  '账单过期,账单生成后3个月内有效,以生成账单日期起,3个月后的账单将无法开票。例：202005的账单,于2020-06-10生成,则将于2020-9-31后过期,无法开票。':
    '账单过期,账单生成后3个月内有效,以生成账单日期起,3个月后的账单将无法开票。例：202005的账单,于2020-06-10生成,则将于2020-9-31后过期,无法开票。',
  '发票接收,发票已出票后,请查看您在申请开票所所填写的邮箱。':
    '发票接收,发票已出票后,请查看您在申请开票所所填写的邮箱。',
  月份: '月份',
  金额: '金额',
  发票金额: '发票金额',
  发票月份: '发票月份',
  发票详情: '发票详情',
  开票状态: '开票状态',
  '加载中...': '加载中...',
  技术服务费: '技术服务费',
  会员服务费: '会员服务',
  电子普通发票: '电子普通发票',
  '金币充值1元起充,1元=1金币（可用于会员充值、海报购买、模型购买等）；':
    '金币充值1元起充,1元=1金币（可用于会员充值、海报购买、模型购买等）；',
  '因目前相关政策限制,充值成功后,充值资金仅限于购买本站付费服务或购买本站提供的第三方付费服务,不支持任何形式与理由进行提现或者申请退款,敬请知悉！':
    '因目前相关政策限制,充值成功后,充值资金仅限于购买本站付费服务或购买本站提供的第三方付费服务,不支持任何形式与理由进行提现或者申请退款,敬请知悉！',
  选择支付类型: '选择支付类型',
  请输入充值金额: '请输入充值金额',
  实际到账金额: '实际到账金额',
  确定充值: '确定充值',
  充值记录: '充值记录',
  云展动力收银台: '云展动力收银台',
  应付金额: '应付金额',
  微信扫码支付: '微信扫码支付',
  我已支付: '我已支付',
  充值成功: '充值成功',
  充值失败: '充值失败',
  '很抱歉,金额过高,请再次检查是否填写有误': '很抱歉,金额过高,请再次检查是否填写有误',
  请输入金额: '请输入金额',
  '最低提现金额为xx元起,提现手续费xx%': '最低提现金额为xx元起,提现手续费xx%',
  '提现到账时间为1-5个工作日,节假日顺延': '提现到账时间为1-5个工作日,节假日顺延',
  '提现申请成功,请等待后台审核': '提现申请成功,请等待后台审核',
  请点击发送验证码: '请点击发送验证码',
  点击发送验证码: '点击发送验证码',
  请输入提现金额: '请输入提现金额',
  请输入支付宝账号: '请输入支付宝账号',
  请输入支付宝收款人姓名: '请输入支付宝收款人姓名',
  请输入收款人名称: '请输入收款人名称',
  提现金额: '提现金额',
  '手续费率3%': '手续费率3%',
  支付宝账号: '支付宝账号',
  '请输入支付宝账户/手机号码': '请输入支付宝账户/手机号码',
  提交申请: '提交申请',
  提现记录: '提现记录',
  提现信息确认: '提现信息确认',
  收款人姓名: '收款人姓名',
  请输入短信验证码: '请输入短信验证码',
  立即提现: '立即提现',
  首位绑定子账号: '首位绑定子账号',
  当前绑定的子账号: '当前绑定的子账号',
  '确定要解绑吗？解绑成功后,该客户之后所产生所有的数据都不归当前子账号所属':
    '确定要解绑吗？解绑成功后,该客户之后所产生所有的数据都不归当前子账号所属',
  绑定成功: '绑定成功',
  解绑成功: '解绑成功',
  子账号详情: '子账号详情',
  操作成功: '操作成功',
  重置成功: '重置成功',
  绑定时间: '绑定时间',
  指派时间: '指派时间',
  重置密码: '重置密码',
  启用: '启用',
  重置登录密码: '重置登录密码',
  客户绑定列表: '客户绑定列表',
  客户公司: '客户公司',
  '确定要解绑吗？': '确定要解绑吗？',
  解绑: '解绑',
  展馆名称: '展馆名称',
  请输入展馆名称: '请输入展馆名称',
  展馆面积: '展览面积',
  展馆图片: '展览图片',
  示例图: '示例图',
  空地展位: '空地展位',
  自定义: '自定义',
  '注意：若国内企业/境外企业的展位价格输入为0元（或美元）,客户看到的则显示为【面议】,例如：国内企业（RMB）：面议':
    '注意：若国内企业/境外企业的展位价格输入为0元（或美元）,客户看到的则显示为【面议】,例如：国内企业（RMB）：面议',
  平方米: '平方米',
  请输入豪华标准展位所提供的物品: '请输入豪华标准展位所提供的物品',
  请输入基本标准展位所提供的物品: '请输入基本标准展位所提供的物品',
  请输入空地展位所提供的物品: '请输入空地展位所提供的物品',
  请输入面积: '请输入面积',
  请上传展览云图: '请上传展览云图',
  请上传展览主图: '请上传展览云图',
  请输入展览面积: '请输入展览面积',
  展览时间不能为空: '展览时间不能为空',
  手机国际号: '手机国际号',
  请选择手机国际地区: '请选择手机国际地区',
  更换定位: '更换定位',
  更换地区: '更换地区',
  热门城市: '热门城市',
  清除所选项: '清除所选项',
  收起筛选: '收起筛选',
  展开筛选: '展开筛选',
  国内热门城市: '国内热门城市',
  '平均时长：分钟/次': '平均时长：分钟/次',
  'raido-中文': '简体中文',
  'raido-英文': 'English(英文)',
}
